import { useEffect, useState, useRef } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useForm, Controller } from "react-hook-form";
import API from "utils/Axios";
import Errors from "components/Errors";
import Select from "react-select";
import { FaPlus } from "react-icons/fa";
// import { LugarPracticasFormulario } from "components/LugarPracticas/Formulario";

const LugarPractica = ({
  field,
  labelKey = "a_titulo",
  name = "lugar",
  mostrarTodos = false,
  watch,
}) => {
  const [value, setValue] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [lugares, setLugares] = useState([]);
  const [visible, setVisible] = useState(false);
  const [autoridadGuardada, setAutoridadGuardada] = useState([]);
  const select = useRef();
  const lugar = watch(name);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldFocusError: true,
  });

  function filterBy(option, state) {
    if (state.selected.length) {
      return true;
    }
    return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
  }

  const cargarLugares = () => {
    API("configuracion/entidad/").then(({ data }) => {
      setLugares(data.map((d) => ({ value: d.id, label: d[labelKey] })));
    });
  };

  const checkKeyDown = (e) => {
    if (e.code === "Enter") e.preventDefault();
  };

  const guardar = async (payload) => {
    try {
      setCargando(true);
      const { data } = await API.post("configuracion/entidad/", payload);
      setValue({ value: data.id, label: data[labelKey] })
      setCargando(false);
      setVisible(false);
    } catch (error) {
      setCargando(false);
    }
  };
  const onError = () => {};
  const submit = (event) => {
    console.log(event);
    if (event) {
      // sometimes not true, e.g. React Native
      if (typeof event.preventDefault === "function") {
        event.preventDefault();
      }
      if (typeof event.stopPropagation === "function") {
        // prevent any outer forms from receiving the event too
        event.stopPropagation();
      }
    }
    return handleSubmit(guardar, onError)(event);
  };

  useEffect(() => {
    cargarLugares();
  }, []);

  useEffect(() => {
    const _lugar = lugares.find((l) => l.value == lugar);
    if (_lugar) {
      setValue(_lugar);
    } else {
      setValue(null);
    }
  }, [lugar, lugares]);

  return (
    <>
      {/* <Select
        closeMenuOnSelect={true}
        isClearable
        value={value}
        placeholder="Seleccione un lugar"
        options={lugares}
        onChange={(d) => {
          field.onChange(d?.value);
        }}
      /> */}

<Modal
      show={visible}
      onHide={() => setVisible(false)}
      backdrop="static"
      keyboard={false}
    >
      <Form noValidate onSubmit={submit} onKeyDown={(e) => checkKeyDown(e)}>
        <Modal.Header closeButton={!cargando}>
          <Modal.Title>Agregar autoridad</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Controller
            name="a_titulo"
            control={control}
            defaultValue=""
            rules={{ required: "Ingrese información" }}
            render={({ field }) => (
              <Form.Group>
                <Form.Label>
                  Nombre <span className="required" />
                </Form.Label>
                <Form.Control {...field} disabled={cargando} />
                <Errors message={errors?.a_titulo?.message} />
              </Form.Group>
            )}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" disabled={cargando}>
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
      
      <Form.Label>Lugar de prácticas <span className="required" /></Form.Label>
      <div class="input-group mb-3 d-flex">
        <div class="input-group-prepend">
          <button
            class="btn btn-outline-secondary"
            type="button"
            onClick={() => setVisible(true)}
          >
            <FaPlus />
          </button>
        </div>
        {/* <Form.Control as="select" {...field} ref={select}>
          <option value="">Seleccione...</option>
          {lugares.map((el) => (
            <option value={el.value} key={el.value}>
              {el.label}
            </option>
          ))}
        </Form.Control> */}
        <div style={{ display: 'flex', flex: 1 }} className="container-select">
          <Select
            closeMenuOnSelect={true}
            isClearable
            value={value}
            placeholder="Seleccione un lugar"
            options={lugares}
            styles={{ flex: 1 }}
            onChange={(d) => {
              field.onChange(d?.value);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default LugarPractica;
